import { EARN_DASHBOARD_STATE } from '../../types'
import { EarnDirectDashboardData, UseEarnPageDataHandlers } from '../../types/dashboardState'
import { formatUsd } from '../../utils/utils'
import { useEarnDashboardBaseData } from './useEarnDashboardBaseData'

export const useEarnDirectDashboardData = (
  handlers: UseEarnPageDataHandlers
): EarnDirectDashboardData => {
  const baseData = useEarnDashboardBaseData(handlers)

  if (baseData.dashboardState !== EARN_DASHBOARD_STATE.READY) {
    return baseData
  }

  const { dashboard, assets, isStatisticsLoading, summary } = baseData

  return {
    dashboardState: EARN_DASHBOARD_STATE.READY,
    assets,
    isStatisticsLoading,
    summary: {
      ...summary,
      totalAllTimeEarnings: formatUsd(dashboard.totalEarnings.fromMyAllocation),
    },
  }
}
